import { useCallback, useMemo } from 'react';

import { Bean, useTranslate, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../../../translations';
import { SETTLEMENT_TYPES } from '../../../settlement/settlement.types';
import { MedicalServicePractitionerBean, MedicalServicePractitionerSettlementType } from '../../practitioner.types';

export const useToggleLabelExtractor = (): ((item?: MedicalServicePractitionerSettlementType) => string) => {
   const translate = useTranslate();

   return useCallback(
      (item) => {
         return translate(medicalServiceTranslationKeys.shared.settlementType.cell.map[item!]);
      },
      [translate]
   );
};

type MedicalServicePractitionerSettlementTypeCellProps = InteractiveTableCellProps<MedicalServicePractitionerSettlementType> & {
   readonly defaultValue: MedicalServicePractitionerSettlementType;
};

export const MedicalServicePractitionerSettlementTypeCell = (
   props: MedicalServicePractitionerSettlementTypeCellProps
): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<MedicalServicePractitionerBean>();
   const triggerLabelExtractor = useToggleLabelExtractor();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: !usingDefaultConfiguration,
      };
   }, [usingDefaultConfiguration]);

   return (
      <InteractiveTable.SelectCell<MedicalServicePractitionerSettlementType>
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
         validationRules={validationRules}
         triggerLabelExtractor={triggerLabelExtractor}
         disabled={usingDefaultConfiguration}
      >
         <InteractiveTable.SelectCell.List items={SETTLEMENT_TYPES}>
            {(type) => (
               <InteractiveTable.SelectCell.Item
                  item={type}
                  label={medicalServiceTranslationKeys.shared.settlementType.cell.map[type]}
                  testId={type}
               />
            )}
         </InteractiveTable.SelectCell.List>
      </InteractiveTable.SelectCell>
   );
};
